/**
 * Styled wrapper around React Router's Link that strips default text-decoration.
 *
 * @module components/common/StyledLink
 * @author Covintus
 * @author Snowfly
 * @version 1.0.0
 */
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

/**
 * A styled component that wraps the Link component to ensure consistent styling.
 *
 * StyledLink removes all text decoration (e.g., underline) in its different states,
 * including focus, hover, visited, link, and active. It inherits all other behaviors
 * of the underlying Link component while applying custom styles.
 *
 * This component is typically used for navigation purposes where the default
 * text decoration styling from the browser or parent component is undesired.
 */
const StyledLink = styled(Link)`
  text-decoration: none;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;

// eslint-disable-next-line react/display-name
export default (props) => <StyledLink {...props} />;
